module.exports = __webpack_public_path__ + "static/img/165_TO8_1905.6d2523d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/165_TO8_1905.jpg
// module id = aYJS
// module chunks = 0